import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useState, useCallback, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { useModalsComponentsManager } from '@panneau/core/contexts';
import { useActionProps } from '@panneau/core/hooks';
import Button from '@panneau/element-button';

var styles = {};

var _excluded = ["id", "title", "description", "fields", "endpoint", "label", "icon", "value", "theme", "disabled", "onChange", "onConfirmed", "valueLabelPath", "modalComponent", "withConfirmation", "className"];
var propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.node,
  description: PropTypes.node,
  fields: PropTypes.arrayOf(PropTypes.shape({})),
  endpoint: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.bool,
  icon: PropTypes.string,
  theme: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  onConfirmed: PropTypes.func,
  valueLabelPath: PropTypes.string,
  modalComponent: PropTypes.string,
  withConfirmation: PropTypes.bool,
  className: PropTypes.string
};
var defaultProps = {
  title: null,
  description: null,
  fields: null,
  endpoint: null,
  label: /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "Ke35Pv",
    defaultMessage: [{
      "type": 0,
      "value": "Edit"
    }]
  }),
  icon: 'pencil',
  value: null,
  theme: 'primary',
  disabled: false,
  onChange: null,
  onConfirmed: null,
  valueLabelPath: null,
  modalComponent: 'form',
  withConfirmation: false,
  className: null
};
var EditAction = function EditAction(_ref) {
  var id = _ref.id,
    title = _ref.title,
    description = _ref.description,
    fields = _ref.fields,
    endpoint = _ref.endpoint,
    label = _ref.label,
    icon = _ref.icon,
    value = _ref.value,
    theme = _ref.theme,
    disabled = _ref.disabled,
    onChange = _ref.onChange,
    onConfirmed = _ref.onConfirmed,
    valueLabelPath = _ref.valueLabelPath,
    modalComponent = _ref.modalComponent,
    withConfirmation = _ref.withConfirmation,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  var ModalComponents = useModalsComponentsManager();
  var ModalComponent = ModalComponents.getComponent(modalComponent);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    modalOpen = _useState2[0],
    setModalOpen = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    error = _useState4[0],
    setError = _useState4[1];
  var _useActionProps = useActionProps(id, value, valueLabelPath),
    ids = _useActionProps.ids,
    idLabels = _useActionProps.idLabels,
    modalKey = _useActionProps.modalKey;
  var onOpen = useCallback(function () {
    setModalOpen(true);
  }, [setModalOpen]);
  var onClose = useCallback(function () {
    setModalOpen(false);
  }, [setModalOpen]);
  var onComplete = useCallback(function (newValue) {
    setModalOpen(false);
    if (onConfirmed !== null) {
      onConfirmed(newValue);
    }
    if (onChange !== null) {
      onChange(newValue);
    }
  }, [onChange, setModalOpen, modalKey]);
  var onError = useCallback(function () {
    setError(true);
  }, [setError]);
  var multipleValues = useMemo(function () {
    return value !== null && value.length > 1;
  }, [value]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, Object.assign({
    className: classNames([styles.container, _defineProperty({}, className, className !== null)]),
    label: label,
    icon: icon,
    onClick: withConfirmation ? onOpen : null,
    disabled: disabled,
    theme: disabled ? 'secondary' : theme
  }, props)), modalOpen ? /*#__PURE__*/React.createElement(ModalComponent, {
    id: modalKey,
    title: title || (multipleValues ? /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "sOfogS",
      defaultMessage: [{
        "type": 0,
        "value": "Edit items"
      }]
    }) : /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "Mohaye",
      defaultMessage: [{
        "type": 0,
        "value": "Edit item"
      }]
    })),
    onClose: onClose,
    onComplete: onComplete,
    onError: onError,
    postData: {
      ids: ids
    },
    fields: fields,
    action: endpoint
  }, description || /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "ucieFX",
    defaultMessage: [{
      "type": 0,
      "value": "The following items will be modified: "
    }, {
      "type": 1,
      "value": "ids"
    }, {
      "type": 0,
      "value": "."
    }],
    values: {
      ids: idLabels
    }
  })), error !== null ? /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "cutyQH",
    defaultMessage: [{
      "type": 0,
      "value": "An error has occured."
    }]
  }) : null) : null);
};
EditAction.propTypes = propTypes;
EditAction.defaultProps = defaultProps;

export { EditAction as default };
